import { useCallback, useState } from "react";
import PromptDialog from "@entrilia/shared/components/dialog/PromptDialog.tsx";
import { logError } from "@entrilia/shared/logging.ts";
import type { RenameReportRequest, Report } from "../../../../../../api/types/svTypes.ts";
import type { FromReport } from "./FromReport.ts";
import SaveReportFormWrapper from "./SaveReportFormWrapper.tsx";

interface Props {
  report: FromReport;
  renameReport: (report: RenameReportRequest) => Promise<Report | undefined>;
  onChanged: (report: Report) => void;
  onClose: () => void;
}

export default function RenameReport(props: Props) {
  const { report, renameReport, onChanged, onClose } = props;

  const [error, setError] = useState<string>();
  const [saving, setSaving] = useState(false);

  const onSaveClicked = useCallback(
    async (name: string) => {
      setSaving(true);
      try {
        const resp = await renameReport({ reportId: report.reportId, name, clientCode: report.clientCode });
        if (resp === undefined) {
          setError("An error occurred while renaming the report.");
        } else {
          onChanged(resp);
          onClose();
        }
      } catch (e) {
        logError(e, "[RenameReport] renameReport");
        setError("An error occurred while renaming the report.");
      } finally {
        setSaving(false);
      }
    },
    [onChanged, onClose, renameReport, report.clientCode, report.reportId]
  );

  return (
    <PromptDialog open={true}>
      <SaveReportFormWrapper
        report={report}
        error={error}
        title="Rename Report"
        saveBtnTitle="Save"
        saving={saving}
        showName
        onClose={onClose}
        onSave={onSaveClicked}
      />
    </PromptDialog>
  );
}
